import {detail, list} from "@mc/mc-legacy";
import * as localStorageUtils from "../utils/localStorageUtils";
import {SPOLECNOST_ID_KEY} from "../const/const";
import SubjektApi from "../api/gen/cgo/SubjektApi";

export const SHARED_AREA = "uzivatel";
export const PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA = `${SHARED_AREA}.spolecnostId`;
export const PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA = `${SHARED_AREA}.spolecnostiList`;
export const AD_IMPORT_AREA = `adImport`;

/**
 * Načtení ID právě vybrané společnosti uživatele z local storage.
 * @returns {Function}
 */
export function fetchSpolecnostIdIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA, uzivatelId, (parent) => {
            return Promise.resolve(localStorageUtils.load(parent, SPOLECNOST_ID_KEY));
        }));
    }
}

/**
 * Zneplatnění ID právě vybrané společnosti uživatele.
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function invalidateSpolecnostId(uzivatelId) {
    return (dispatch) => {
        dispatch(detail.DetailActions.invalidate(PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA, uzivatelId));
    }
}

/**
 * Načtení seznamu společností přihlášeného uživatele.
 *
 * @param uzivatelId ID uživatele
 * @returns {Function}
 */
export function fetchSpolecnostiPrihlasenyUzivatelIfNeeded(uzivatelId) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA, uzivatelId, (parent) => {
            return SubjektApi.getSpolecnostiUzivatel(parent, false);
        }));
    }
}

/**
 * Zneplatnění seznamu společností přihlášeného uživatele.
 *
 * @returns {Function}
 */
export function invalidateSpolecnostiPrihlasenyUzivatel() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA));
    }
}

/**
 * Sppuštění importu osob z AD.
 *
 * @returns {Function}
 */
export function importUsersFromAD() {
    return (dispatch) => {
        dispatch(() => {
            return SubjektApi.importUsersFromAD();
        });
    }
}

/**
 * Zjistí zda je import povolen/nastaven.
 *
 * @returns {Function}
 */
export function fetchAdImportIfNeeded() {
    return (dispatch) => {
        dispatch(detail.DetailActions.fetchIfNeeded(AD_IMPORT_AREA, "adImport", () => {
            return SubjektApi.isImportFromADEnabled();
        }));
    }
}
